import feed from '../../components/feed';

import QuickView from '../product/quickView';
import listener from '../../utils/listener';

document.addEventListener('DOMContentLoaded', (e) => {
  new QuickView().init();
  if (window.dataLayer) {
    listener.dataLayerAddToCartHandler();
  }
  handleAccessibilityComponents();
});

export default class HomeClass {
  constructor() {
    this.$instagramFeeds = $('.instagram-feed');
  }

  init() {
    if (this.$instagramFeeds.length > 0) {
      return feed.get(this.$instagramFeeds);
    }
  }
}

function handleAccessibilityComponents() {
  if ($('.accessibility-focus').length > 0) {
    $('.accessibility-focus .splide__slide').on('keyup', (e) => {
      $('.accessibility-focus .splide__slide').removeClass('focus-tab');
      if (e.code === 'Tab' || e.key === 'Tab') {
        $(e.currentTarget).addClass('focus-tab');
      }
    });
  }
}
